import { render, staticRenderFns } from "./DeleteResourceChapterConfirm.vue?vue&type=template&id=56809c12&scoped=true&"
import script from "./DeleteResourceChapterConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteResourceChapterConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56809c12",
  null
  
)

export default component.exports